import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { UpdateCwsIconPublishOrderVo } from '../vo/update-cws-Icon-publish-order.model'

/**
 * アイコン掲載順更新
 *
 * @export
 * @class UpdateCwsIconPublishOrder
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateCwsIconPublishOrder extends PlessJsonResponderSub<any> {
  private voList: UpdateCwsIconPublishOrderVo[];
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateCwsIconPublishOrder
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        IconPublishOrderList: this.voList.map((vo) => {
          return {
            combination: {
              parameter: {
                PublishOrder: vo.publishOrder,
                IconCode: vo.iconCode
              }
            }
          }
        })
      }
    });
  }

  /**
   * API呼び出し
   *
   * @memberof UpdateCwsIconPublishOrder
   */
  execute(voList: UpdateCwsIconPublishOrderVo[], successFunc: Function = null): void {
    this.voList = voList;
    this.successFunc = successFunc;
    this.send('updateCwsIconPublishOrder', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateCwsIconPublishOrder
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
